export const SCHEDULER = 'scheduler'
export const CHANGE_PERMISSIONS = 'change_permissions'
export const ACCESS_PERMISSIONS = 'access_permissions'
export const IT_REGISTRATION = 'it_registration'
export const CARD95_ADMIN = 'card95_admin'
export const CARD95_VIEWER = 'card95_viewer'
export const ACCESS_CARD99_EXTEND = 'card99_extend_check'
export const CARD99_VIEWER = 'card99_viewer'
export const CARD99_ADMIN = 'card99_admin'
export const CARD97_BREAKER_VERIFY = 'card97_pibreaker_verify' // conditional
export const CARD97_ADMIN = 'card97_admin'
export const CARD97_DUKE_FOS_REFERENCE = 'card97_duke_fos_reference'
export const CARD97_VIEWER = 'card97_viewer'
export const CARD97_FILTER = 'card97_filter'
export const CARD97_EXCLUSION_EVENT_WRITE = 'card97_exclusion_event_write'
export const CARD97_EXCLUSION_EVENT_READ = 'card97_exclusion_event_read'
// export const CARD_HISTORY_VIEWER = 'card_hiostory_viewer'
export const CARD95_HISTORY_VIEWER = 'card95_hiostory_viewer'
export const CARD97_HISTORY_VIEWER = 'card97_hiostory_viewer'
export const CARD99_HISTORY_VIEWER = 'card99_hiostory_viewer'

export const CARDDATA_IMPORT = 'data_import'
export const CARDDATA_IMPORT_TWOFILE = 'data_import_twofile'
// export const CARDDATA_IMPORT_EDITED_RESUBMIT='carddata_import_resubmit'

export const VALIDATION_RUNCHECK = 'validation_runcheck'
export const VALIDATION_LOG = 'validation_log'
export const VALIDATION_BLOCK_LEVEL_2_PROCESSING =
  'block_level_2_processing_validation'
export const VALIDATION_EVENT_PENDING = 'validation_event_pending'
export const VALIDATION_EVENT_PENDING_APPROVAL =
  'validation_event_pending_approval'
export const DAILY_OPERATION_VIEW = 'daily_operation_view'
export const UNIT_DAILY_OPERATION_VIEW = 'unit_daily_operation_view'
export const AECI_UNITHOURLY_READ = 'aeci_unithourly_read'
export const AECI_UNITHOURLY_WRITE = 'aeci_unithourly_write'
export const MONTHLY_OPERATION_VIEW = 'monthly_operation_view'
export const MONTHLY_OPERATION_SAVE_PERF_DATA =
  'monthly_operation_save_perf_data'
export const MONTHLY_OPERATION_VIEW_KPI_DATA = 'monthly_operation_view_kpi'
export const MONTHLY_OPERATION_ADMIN_KPI_DATA = 'monthly_operation_admin_kpi'
export const NERC_FILE_CREATION = 'nerc_file'
export const PJM_FILE_CREATION = 'pjm_file'
export const REPORT_ACCESS = 'reports'
export const REPORT_JASPER_ACCESS = 'reports_jasper'
export const NONHYDRO_VIEW = 'nonhydro_view'
export const NONHYDRO_ADD_DATA = 'nonhydro_add_data'
export const NONHYDRO_IMPORT = 'nonhydro_import'
export const NONHYDRO_PROCESS = 'nonhydro_process'
export const HYDRO_VIEW = 'hydro_view'
export const HYDRO_ADD_DATA = 'hydro_add_data'
export const HYDRO_IMPORT = 'hydro_import'
export const HYDRO_PROCESS = 'hydro_process'
export const RENAME_HYDRO_TO_BREAKER_EVENT = 'rename_hydro_to_breaker_event'
export const NERC_CAPACITY_USER = 'user_nerc_capacity'
export const NERC_CAPACITY_USER_ADMIN = 'user_nerc_capacity_admin'

export const MW_IMPORT_VIEWER = 'mw_import_viewer'
export const MW_IMPORT_ADMIN = 'mw_import_admin'
export const BREAKER_IMPORT_VIEWER = 'breaker_import_viewer'
export const BREAKER_IMPORT_ADMIN = 'breaker_import_admin'
export const CRANECREEK_IMPORT_ADMIN = 'cranecreek_import_admin'
export const CRANECREEK_IMPORT_VIEWER = 'cranecreek_import_viewer'
export const FORWARD_IMPORT_ADMIN = 'forward_import_admin'
export const FORWARD_IMPORT_VIEWER = 'forward_import_viewer'
export const BSGF_IMPORT_ADMIN = 'bsgf_import_admin'
export const BSGF_IMPORT_VIEWER = 'bsgf_import_viewer'
export const GHWP_IMPORT_ADMIN = 'ghwp_import_admin'
export const GHWP_IMPORT_VIEWER = 'ghwp_import_viewer'
export const TURBINE_POINTS_IMPORT_VIEWER = 'turbine_points_import_viewer'
export const TURBINE_POINTS_IMPORT_ADMIN = 'turbine_points_import_admin'
export const BSGF_GHWP_ERROR_MAP_IMPORT_ADMIN = 'bsgf_ghwp_import_admin'
export const BSGF_GHWP_ERROR_MAP_IMPORT_VIEWER = 'bsgf_ghwp_import_viewer'

export const GRAPH_MW = 'graph_mw'
export const GRAPH_COMMERCIAL = 'graph_commercial'
export const GRAPH_FORECAST = 'graph_forecast'

export const SWITCHBOARD = 'switchboard'
export const SWITCHBOARD_IMPORT = 'switchboard_import'
export const MONTHLY_PERF_DATA = 'monthly_performance_data'
export const MONTHLY_PERF_DATA_ADMIN = 'monthly_performance_data_admin'
export const REPORT_EXCEL = 'reports_excel'

export const PROCESS_DATA_WITH_FILE_UPLOAD = 'process_data_with_file_upload'
export const DERATE_VIEW = 'hourly_derate_view'
export const DERATE_PROCESS = 'hourly_derate_process'
export const DERATE_CAUSECODE_VIEW = 'hourly_derate_causecode_view'
export const DERATE_CAUSECODE_PROCESS = 'hourly_derate_causecode_process'
export const DERATE_PROCESS_NYISO = 'derate_process_nyiso'
export const REQUEST_GENERATION_DATA = 'request_generation_data'
export const WEBSERVICE_ACCESS_PERMISSIONS = 'webservice_access_permissions'
export const VIEW_GENERATION = 'view_generation'
export const ADMIN_GENERATION = 'admin_generation'
export const VIEW_GENERATION_AUX = 'view_generation_aux'
export const ADMIN_GENERATION_AUX = 'admin_generation_aux'
export const VIEW_GENERATION_BY_HOUR = 'view_generation_by_hour'
export const ADMIN_GENERATION_BY_HOUR = 'admin_generation_by_hour'
export const GENERATION_BY_HOUR_WITH_SYNCH = 'generation_by_hour_with_synch'
export const GENERATION_BY_HOUR_WITH_PUMP = 'generation_by_hour_with_pump'
export const GENERATION_BY_HOUR_HIDE_DELETE = 'generation_by_hour_hide_delete'
export const GENERATION_BY_HOUR_WITH_AUX = 'generation_by_hour_with_aux'
export const VIEW_GENERATION_BY_HOUR_DOM = 'view_generation_by_hour_dom'
export const ADMIN_GENERATION_BY_HOUR_DOM = 'admin_generation_by_hour_dom'
export const VALIDATION_MONTHLY = 'validation_monthly'

export const REPORT_DASHBOARD_ACCESS = 'report_dashboard'
export const REPORT_PERFORMANCE_MEASURES_VIEW =
  'reports_performance_measures_view'
export const REPORT_PERFORMANCE_MEASURES_ADMIN =
  'reports_performance_measures_admin'

export const REPORT_ADHOCK_ACCESS_PDF = 'adhock_reports_pdf'
export const REPORT_ADHOCK_ACCESS_EXCEL = 'adhock_reports_excel'
// nyiso below this is used client wants all data without checking the retired or commissined date
export const ADHOC_SHOW_ALL_UNITS_BYUSER = 'adhock_show_all_units_byuser'
export const ADHOC_HIDE_CALC_METHOD = 'adhoc_hide_calc_method'
export const ADHOC_CALC_METHOD_ISO = 'adhoc_calc_method_iso'
export const REPORT_ADHOC_PROCESS = 'adhoc_report_process'

export const WIND_POWER_DATA = 'wind_power_data'
export const WIND_ADMIN_POWER_DATA = 'wind_admin_power_data'
export const WIND_ADHOC_MATRIX_REPORT = 'wind_adhoc_matrix_report'
export const WIND_ADMIN_SCRREEN_PERMISSIONS = 'wind_admin_screen'

export const WIND_POWER_DATA_20 = 'wind_power_data_20'
export const WIND_ADMIN_POWER_DATA_20 = 'wind_admin_power_data_20'
export const WIND_ADHOC_MATRIX_REPORT_20 = 'wind_adhoc_matrix_report_20'
export const WIND_ADMIN_SCRREEN_PERMISSIONS_20 = 'wind_admin_screen_20'
export const WIND_IMPORT_CSV_20 = 'wind_import_csv_20'
export const WIND_REPORT_20 = 'wind_report_20'
export const WIND20_SCREEN_MENU_SHOW_ONLY = 'wind20_screen_menu_show_only'
export const WIND2_FILE_CREATION = 'wind2_file_creation'
export const WIND2_FILE_IMPORT = 'wind2_file_import'
export const WIND2_PI_IMPORT_INTERVALS = 'wind2_pi_import_intervals'
export const WIND2_PI_MISSING_DATA = 'wind2_pi_data_missing'
export const HIDE_WIND2_TURBINE_PERFORMANCE = 'hide_wind2_turbine_performance'
export const WIND2_PI_ROW_DATA_READ = 'wind2_pi_row_data_read'
export const WIND2_PI_ROW_DATA_WRITE = 'wind2_pi_row_data_write'
export const WIND2_UPDATE_CAUCECODE_TURBINEEVENT =
  'wind2_update_causecode_turbineevent'

export const SOLAR_POWER_DATA = 'solar_power_data'
export const SOLAR_ADMIN_POWER_DATA = 'solar_admin_power_data'
export const SOLAR_ADHOC_MATRIX_REPORT = 'solar_adhoc_matrix_report'
export const SOLAR_ADMIN_SCRREEN_PERMISSIONS = 'solar_admin_screen'
export const SOLAR_FILE_CREATION = 'solar_file_creation'
export const SOLAR_FILE_IMPORT = 'solar_file_import'
export const SOLAR_FILE_IMPORT_CSV = 'solar_file_import_csv'
export const SOLAR_SCREEN_MENU_SHOW_ONLY = 'solar_screen_menu_show_only'
export const SOLAR_REPORT = 'solar_report'
export const SOLAR_PI_MISSING_DATA = 'solar_pi_data_missing'
export const SOLAR_PI_IMPORT_INTERVALS = 'solar_pi_import_intervals'
export const HIDE_SOLAR_INVERTER_DATA = 'hide_solar_inverter_data'
export const SHOW_SOLAR_STORAGE_DATA = 'show_solar_storage_data'
export const SHOW_SOLAR_STORAGE_STANDALONE_DATA =
  'solar_storage_standalone_view'
export const SHOW_SOLAR_STORAGE_STANDALONE_DATA_ADMIN =
  'solar_storage_standalone_admin'
// export const SHOW_FILTER_GENERIC = 'show_filter_drawer'

export const SOLAR_PI_ROW_DATA_READ = 'solar_pi_row_data_read'
export const SOLAR_PI_ROW_DATA_WRITE = 'solar_pi_row_data_write'
export const SOLAR_GENERATION_DATA_READ = 'solar_generation_data_read'
export const SOLAR_GENERATION_DATA_WRITE = 'solar_generation_data_write'
export const SOLAR_PLANT_EXTRA_INFO = 'solar_plant_extra_info'
export const SOLAR_UPDATE_CAUCECODE_INVERTEREVENT =
  'solar_update_causecode_inverterevent'
export const SOLAR_DAYS_CREATION = 'solar_days_creation'

export const TALEN_NEISO_FILE_CREATION = 'talen_neiso_file_creation'
export const NEISO_FILE_CREATION = 'neiso_file_creation'
export const TALEN_NYISO_FILE_CREATION = 'talen_nyiso_file_creation'
export const TALEN_ADDITIONAL_EVENT_TAGS = 'additional_event_tags'
export const TALEN_ADDITIONAL_MONTHLY_TAGS = 'additional_monthly_tags'
export const TALEN_PROCESS_ALL = 'talen_process_all'
export const TALEN_VALIDATE_PROCESS_ALL = 'talen_validate_process_all'
export const TALEN_ADDN_MONTHLY_TRACKING = 'talen_addn_monthly_tracking'
export const PROFIT_COST = 'profitcost'
export const NRG_EVENT_REPORT_SPEC = 'nrg_event_report_spec'

export const TALEN_USER_MESSAGE = 'user_message'
export const TALEN_USER_MESSAGE_CATEGORY = 'user_message_category'
export const TALEN_MESSAGE_CATEGORY = 'message_category'

export const PI_READ_TAG_MANAGEMENT = 'pi_read_tag_management'
export const PI_WRITE_TAG_MANAGEMENT = 'pi_write_tag_management'
export const PI_DATA_IMPORT = 'pi_data_import'
export const PI_DATA = 'pi_data'
export const PI_READ_MONTHLY_SUMMARY = 'pi_read_monthly_summary'
export const PI_WRITE_MONTHLY_SUMMARY = 'pi_write_monthly_summary'
export const PITAG_ADMIN = 'pitag_admin'

export const EVENT_DASHBOARD = 'event_dashboard'
export const SRP_EVENT_DASHBOARD = 'srp_event_dashboard'

export const NON_OUTAGE_SPILL_READ = 'non_outage_spill_read'
export const NON_OUTAGE_SPILL_ADMIN = 'non_outage_spill_admin'

// margin analysis
export const MARGIN_ANALYSIS_ADMIN = 'marginanalysis_main_admin'
export const MARGIN_ANALYSIS_READ = 'marginanalysis_main_read'
export const MARGIN_ANALYSIS_CORE_WRITE = 'marginanalysis_core_admin'
export const MARGIN_ANALYSIS_CORE_READ = 'marginanalysis_core_read'
export const MARGIN_ANALYSIS_EVENT_PLANNER_SCREEN =
  'marginanalysis_event_planner_screen' // via options
export const MARGIN_ANALYSIS_FORECAST_IMPORT = 'marginanalysis_forecast_import' // via option
export const MARGIN_ANALYSIS_SUMMARY = 'margin_analysis_summary' // via option
export const MARGIN_ANALYSIS_TRUEUP = 'margin_analysis_trueup' // via option

export const PJM_IMPORT_ADMIN = 'pjm_import_admin'
export const PJM_IMPORT_VIEWER = 'pjm_import_viewer'

export const APS_PI_ENTITY = 'aps_pi_ws'

//  below is used for pgads.condition via split
export const UNITMODEL_UTILITY_SEARCH = 'unitmodel_utility_search'
export const UNITS_SHOW_PNODEID = 'units_show_pnodeid' // will show and update pnodeid,emktid and rollup_emktid
export const CARD_FREEZE = 'card_freeze'
export const STATION_HIDE_FMSID = 'station_hide_fmsid'
export const HIDE_PERCENT_OWNERSHIP = 'hide_percent_ownership'
export const HIDE_NERC_CAPACITY = 'hide_nerc_capacity'
export const HIDE_NERC_GROUP = 'hide_nerc_group'
export const OPERATING_DATA = 'operating_data'
export const DATAIMPORT_DISABLE_EDIT = 'dataimport_disable_edit'
export const USER_ROLE_COPY_NAME_ADD = 'user_role_copy_name_add'
export const DATAIMPORT_CSV_TYPE = 'dataimport_csv_type'
export const MONTHLYVIEW_DEFAULT_DETAILS = 'monthlyview_default_details'
export const MARGIN_ANALYSIS_PJMIMPORT = 'marginanalysis_pjmimport'
export const MARGIN_ANALYSIS_PROMOD = 'marginanalysis_promod'
export const MARGIN_ANALYSIS_HIDE_EVENTPLANNER = 'margin_hide_event_planner'
export const MARGIN_ANALYSIS_OA_HOURLY_CA = 'margin_hourly_ca'
export const MEL_CAUSECODE = 'mel_causecode'
export const MEL_COMPONENT = 'mel_component'
export const OA_PNODE_ZONE_HIDE = 'oa_pnode_zone_hide'
export const NERC_FILE_EXPORT_NCEVENT_RADIO_HIDE =
  'nerc_file_export_ncevent_radio_hide'
export const CARD97_DIALOG_MORE_CAUSE_HIDE = 'card97_dialog_more_cause_hide'
export const CARD97_DIALOG_MANHOURS_HIDE = 'card97_dialog_manhours_hide'
export const CARD97_DIALOG_WORKDATE_HIDE = 'card97_dialog_workdate_hide'
export const CARD97_DIALOG_QUICKFILL_MULTIPLE =
  'card97_dialog_quickfill_multiple'
export const SYSTEM_CODE_MANAGEMENT = 'system_code_management'
export const UNIT_EXTENSION_MANAGEMENT = 'unit_extension_management'
export const UNIVERSAL_ID = 'universal_id'
export const HYDRO_NONHYDRO_OPTION_CHANGE = 'hydro_nonhydro_generationend'
export const HYDRO_HIDE_ELEVATION = 'hydro_hide_elevation'
export const HYDRO_HIDE_PUMP = 'hydro_hide_pump'
export const HYDRO_HIDE_SYNC = 'hydro_hide_sync'
export const RIVER_SYSTEM_UNIT = 'river_system_unit' // bkf
export const RIVER_SYSTEM_REGIN = 'river_system_region' // bkf
export const NON_HYDRO_ALL_UNITS = 'non_hydro_all_units'
export const CT_INSPECTION_READ = 'ct_inspection_read'
export const CT_INSPECTION_ADMIN = 'ct_inspection_write'
export const OWNERSHIP_ACCESS_SHOW_COMPANY = 'ownership_access_show_company'
export const NERC_CLASS_AVG_EFORD = 'nerc_class_avg_eford'
export const UNIT_BLOCK = 'unit_block'
export const NYISO_DERATE_GROUP = 'nyiso_derate_group'
export const CONTRIB_CONDITION = 'contrib_condition'
export const USER_SCREEN_HIDE_UPDATE_TAB = 'user_screen_hide_update_tab'
export const PEAK_DEFINITATION = 'peak_definitation'
export const PEAK_DEF_HOLIDAY = 'peak_def_holiday'
export const VALIDATION_HIDE_ERRORDATE = 'validation_hide_errordate'
export const CARD97_FE_DART_EVENT_RECONCILIATION =
  'CARD97_FE_DART_EVENT_RECONCILIATION'
export const CARD97_CUSTOM = 'card97_custom'
export const UNIT_PERFORMANCE_GROUP = 'unit_performance_group'
export const NRG_DATA_ANALYTICS_IMPORT_CARD95 = 'data_analytics_import_card95'
export const NRG_DATA_ANALYTICS_IMPORT_CARD97 = 'data_analytics_import_card97'
export const TVA_MONTHLY_CALCULATION = 'monthly_calculation_save'
/// below is the kindle mysql
export const KINDLE_MYSQL_DA_LMP = 'kindle_mysql_dalmp_read'
export const KINDLE_MYSQL_DA_LMP_ADMIN = 'kindle_mysql_dalmp_admin'
export const KINDLE_MYSQL_RT_LMP = 'kindle_mysql_rtlmp_read'
export const KINDLE_MYSQL_RT_LMP_ADMIN = 'kindle_mysql_rtlmp_admin'
export const KINDLE_MYSQL_GENERATION_READ = 'kindle_mysql_generation_read'
export const KINDLE_MYSQL_GENERATION_ADMIN = 'kindle_mysql_generation_admin'
export const KINDLE_MYSQL_DA_AWARD_ADMIN = 'kindle_mysql_da_award_admin'
export const KINDLE_MYSQL_DA_AWARD_READ = 'kindle_mysql_da_award_read'
export const KINDLE_MYSQL_FUEL_ADMIN = 'kindle_mysql_fuel_admin'
export const KINDLE_MYSQL_FUEL_READ = 'kindle_mysql_fuel_read'

export const BID_OFFER_READ = 'bid_offer_read'
export const BID_OFFER_WRITE = 'bid_offer_write'
export const SCHEDULE_DETAIL_READ = 'schedule_detail_read'
export const SCHEDULE_DETAIL_WRITE = 'schedule_detail_write'
export const OP_THRESHOLD_READ = 'op_reserve_threshold_read'
export const OP_THRESHOLD_WRITE = 'op_reserve_threshold_write'
export const OP_THRESHOLD_IMPORT = 'op_reserve_threshold_import'
export const DALMP_READ = 'outage_analyze_dalmp_read'
export const DALMP_WRITE = 'outage_analyze_dalmp_write'
export const RTLMP_READ = 'outage_analyze_rtlmp_read'
export const RTLMP_WRITE = 'outage_analyze_rtlmp_write'
export const OUTAGE_ANALYZER = 'outage_analyzer'

export const NET_CAP_VERIFICATION = 'net_cap_verification_read'
export const NET_CAP_VERIFICATION_WRITE = 'net_cap_verification_write'
export const NET_CAP_VERIFICATION_IMPORT = 'net_cap_verification_import'
export const NET_CAP_VERIFICATION_EXPORT = 'net_cap_verification_export'
export const VERIFICATION_HOURLY_MWH = 'hourly_mwh_verification'

export const CLECO_GENERATION_IMPORT = 'cleco_generation_import'
export const GENERATION_AUX_IMPORT = 'generation_aux_import'

// export const MONTHL_VIEW_GRAPH_SIZE_800 = will get graph size by last

export const ERROR_LOG_SCREEN_ADMIN = 'stacktrace_log_screen_admin'
export const ERROR_LOG_SCREEN_USER = 'stacktrace_log_screen_user'
export const MISO_MIN_TEST_DURATION = 'miso_min_test_duration'
export const MISO_TEST_DEFAULT = 'miso_test_default'
export const MISO_VERIFICATION_SEASON = 'miso_verification_season'
// export const MISO_USER_SCREEN = 'miso_user_screen'
export const MISO_NET_CAP_VERIFICATION = 'miso_net_cap_verification_read'
export const MISO_NET_CAP_VERIFICATION_WRITE = 'miso_net_cap_verification_write'
export const MISO_NET_CAP_VERIFICATION_IMPORT =
  'miso_net_cap_verification_import'
export const MISO_NET_CAP_VERIFICATION_EXPORT =
  'miso_net_cap_verification_export'

export const VERIFICATION_LOCK = 'verification_lock'

// TPS Interface
export const TPS_UNIT_MAPPING_READ = 'tps_unit_mapping_read'
export const TPS_UNIT_MAPPING_WRITE = 'tps_unit_mapping_write'
export const TPS_MA_DATA_IMPORT = 'tps_ma_data_import'

// TPS File Log
export const TPS_FILE_LOG = 'tps_file_log'

// MISO Interface
export const MISO_UNIT_MAPPING_READ = 'miso_unit_mapping_read'
export const MISO_UNIT_MAPPING_WRITE = 'miso_unit_mapping_write'
export const MISO_MA_DATA_IMPORT = 'miso_ma_data_import'

// PPR
export const PPR_EXPORT = 'ppr_export'

// TPS
export const TPS_MAPPING_READ = 'tps_mapping_read'
export const TPS_MAPPING_WRITE = 'tps_mapping_write'
export const TPS_DATA_READ = 'tps_data_read'
export const TPS_DATA_WRITE = 'tps_data_write'

// WS interface
export const WS_GENERATION_MW = 'ws_generationmw'
export const WS_BREAKER_DATA = 'ws_breakerdata'
export const WS_FUELCOST = 'ws_fuelcost'
export const WS_MARKET_PRICE = 'ws_marketprice'

// lsbp via options
export const LSBP_SF_EVENT_MEASURMENT = 'lsbp_sf_event_measurment'

export const HIDE_CAUSE_CODE_LOOKUP = 'hide_cause_code_lookup'
export const HIDE_EVENT_DURATION_CALCULATOR = 'hide_event_duration_calculator'

// nyiso

export const NYISO_IIFO = 'nyiso_iifo'
export const NYISO_PLW = 'nyiso_plw'
export const NYISO_MARS_PARAMETERS = 'nyiso_mars_parameter'

export const HIDE_DATA_IMPORT_RADIO_GROUP = 'hide_data_import_radio_group'
export const HIDE_DATA_IMPORT_PJM_RADIO_GROUP =
  'hide_data_import_pjm_radio_group'

export const AEP_ACA_SPP_DATA_READ = 'aep_aca_report_spec_read'
export const AEP_ACA_SPP_DATA_WRITE = 'aep_aca_report_spec_write'

export const NERCCAP_IMPORT = 'nerccap_import'

// coop

export const COOP_ASSET_MANAGEMENT = 'coop_asset_management'
